<div class="sh-input-field-with-action -sh-joined-action">
    <div class="sh-input-field-with-action__input">
        <div class="sh-form-multiselect">
            <ul class="sh-tag-list sh-form-tag-list__list--inline-input sh-clear-padding">
                <sh-form-multi-select-base
                    class="sh-form-tag-list__inline-input__pre_input field-search-multiselect"
                    [options]="fieldSearchOptions$ | async"
                    [formControl]="fieldControl"
                    [multiple]="false"
                    [inOverflownContainer]="false"
                    [prefixMsg]="prefix"
                ></sh-form-multi-select-base>
                <li class="sh-form-tag-list__inline-input">
                    <input
                        type="text"
                        class="sh-input-field sh-form-tag-list__inline-input__input-field sh-clear-padding-horizontal sh-clear-margin-top"
                        [formControl]="searchControl"
                        [placeholder]="placeholder"
                        aria-invalid="false"
                        autocomplete="off"
                        (keyup)="onSearchKeyUp($event)"
                    />
                    <div class="sh-form-tag-list__inline-input__highlight"></div>
                </li>
            </ul>
        </div>
    </div>
    <sh-action-item [item]="actionItem" class="sh-form-row-with-action__actions__item -sh-button-spacing"> </sh-action-item>
</div>
